import formatProductCard from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import type { GetProductsParameters } from "@/lib/centra/hooks/useProductFilter/getProducts";
import type { IFilterGroup } from "@/lib/types/centra";

const DEFAULT_PRODUCT_COUNT = 32;

const getFilterParameters = (
  count = DEFAULT_PRODUCT_COUNT,
  productIds: string[] | undefined = undefined,
  categories: string[] = []
) => {
  const category: string[] = categories;
  const filterGroups: IFilterGroup[] = [
    {
      name: "passform",
      fieldOrFunction: "pr_gender"
    }
  ];
  const cardFormatter = formatProductCard;
  return {
    cardFormatter,
    category,
    filterGroups,
    productIds,
    productsPerPage: count
  };
};

export const getProductsFilterParameters = (
  categories: string[] = [],
  productIds: string[] | undefined = undefined,
  count: number = DEFAULT_PRODUCT_COUNT
): GetProductsParameters => {
  const parameteres: GetProductsParameters = getFilterParameters(
    count,
    productIds,
    categories
  );
  return parameteres;
};

export const getSearchFilterParameters = (
  query: string,
  count: number = DEFAULT_PRODUCT_COUNT
) => {
  const { cardFormatter, filterGroups, productsPerPage } = getFilterParameters(
    count,
    undefined,
    []
  );

  return {
    search: query,
    category: [],
    cardFormatter,
    filterGroups,
    productsPerPage
  };
};
